/** Sample form data for auto-fill on Company Policy create page. */
export type PolicyFormSample = {
    title: string;
    code: string;
    description: string;
    content: string;
    effectiveDate?: string;
    /** Optional policy type name to map against loaded policy type list */
    policyTypeName?: string;
};

const todayISO = new Date().toISOString().slice(0, 10);

export const policyFormSamples: PolicyFormSample[] = [
    {
        title: 'ນະໂຍບາຍການລາພັກປະຈຳປີ',
        code: 'POL-LEAVE-001',
        description: 'ກຳນົດຫຼັກເກນ ແລະ ຂັ້ນຕອນການຂໍລາພັກຂອງພະນັກງານ',
        effectiveDate: todayISO,
        policyTypeName: 'ການບໍລິຫານ HR',
        content:
            '1) ພະນັກງານມີສິດລາພັກປະຈຳປີຕາມສັນຍາ\n2) ການຂໍລາຕ້ອງຍື່ນລ່ວງໜ້າຢ່າງໜ້ອຍ 3 ມື້\n3) ຜູ້ບັງຄັບບັນຊາເປັນຜູ້ອະນຸມັດ\n4) ບັນທຶກການລາທຸກຄັ້ງໃນລະບົບ HR',
    },
    {
        title: 'ນະໂຍບາຍການເຮັດ OT',
        code: 'POL-OT-002',
        description: 'ກຳນົດຫຼັກເກນການຂໍ OT, ການອະນຸມັດ ແລະ ການຄິດໄລ່ຄ່າຕອບແທນ',
        effectiveDate: todayISO,
        policyTypeName: 'ແຮງງານ',
        content:
            '1) OT ຕ້ອງໄດ້ຮັບອະນຸມັດກ່ອນປະຕິບັດ\n2) ບັນທຶກເວລາເຂົ້າ-ອອກໃຫ້ຄົບຖ້ວນ\n3) ຝ່າຍ HR ກວດສອບກ່ອນສົ່ງ Payroll\n4) ການຄຳນວນ OT ເປັນໄປຕາມກົດໝາຍແຮງງານ',
    },
    {
        title: 'ນະໂຍບາຍການປະເມີນຜົນການເຮັດວຽກ',
        code: 'POL-PERF-003',
        description: 'ກຳນົດຂອບເຂດ, ຕົວຊີ້ວັດ, ແລະ ຮອບການປະເມີນຜົນ',
        effectiveDate: todayISO,
        policyTypeName: 'ການພັດທະນາພະນັກງານ',
        content:
            '1) ກຳນົດ KPI ໃຫ້ຊັດເຈນຕາມຕຳແໜ່ງ\n2) ປະເມີນຜົນທຸກ 6 ເດືອນ\n3) ປະກອບດ້ວຍ self-review ແລະ manager-review\n4) ຜົນປະເມີນນຳໄປໃຊ້ກັບ IDP ແລະ ການເຕີບໂຕ',
    },
];
